export default {
  getStructure: {
    server: '/projects/{projectId}/structures/{structureId}',
    method: 'get',
  },
  addStructure: {
    server: '/projects/{projectId}/structures',
    method: 'post',
  },
  getStructures: {
    server: '/projects/{projectId}/structures',
    method: 'get',
  },
  putStructure: {
    server: '/projects/{projectId}/structures/{structureId}',
    method: 'put',
  },
  patchStructureGnssConfig: {
    server: '/projects/{projectId}/structures/{structureId}/gnss-config',
    method: 'patch',
  },
  deleteStructure: {
    server: '/projects/{projectId}/structures/{structureId}',
    method: 'delete',
  },
  getStructureTypeOptions: {
    server: '/constants/structure-type-options',
    method: 'get',
  },
  statStructure: {
    server: '/projects/{projectId}/structures/stat',
    method: 'get',
  },

  getMembers: {
    server: '/projects/{projectId}/structures/{structureId}/members',
    method: 'get',
  },
  putMembers: {
    server: '/projects/{projectId}/structures/{structureId}/members',
    method: 'put',
  },
};
